import React from "react";
import classNames from "classnames";
import cls from "./styles.module.scss";

interface SkeletonProps {
  className?: string;
  width?: React.CSSProperties["width"];
  height?: React.CSSProperties["height"];
  radius?: React.CSSProperties["borderRadius"];
}

export const Skeleton: React.FC<SkeletonProps> = ({ className, width, height, radius }) => (
  <div
    aria-hidden="true"
    className={classNames(cls.root, className)}
    style={{
      ...(width !== undefined ? { width } : {}),
      ...(height !== undefined ? { height } : {}),
      ...(radius !== undefined ? { borderRadius: radius } : {}),
    }}
  />
);
